import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = `
Política de Privacidad

Última actualización: Marzo 2026

1. Información que Recopilamos
Recopilamos información personal que usted nos proporciona directamente, como su nombre y dirección de correo electrónico al realizar una compra o suscribirse a nuestro boletín.

2. Uso de la Información
Utilizamos su información personal para:
• Procesar y entregar su compra
• Enviar actualizaciones relacionadas con su pedido
• Mejorar nuestros productos y servicios
• Comunicarnos con usted sobre ofertas relevantes (solo con su consentimiento)

3. Protección de Datos
Implementamos medidas de seguridad técnicas y organizativas para proteger su información personal contra acceso no autorizado, alteración o destrucción.

4. Cookies
Nuestro sitio web utiliza cookies para mejorar su experiencia de navegación y analizar el tráfico del sitio. Puede configurar su navegador para rechazar cookies.

5. Terceros
No vendemos, comerciamos ni transferimos su información personal a terceros sin su consentimiento, excepto cuando sea necesario para procesar su pedido.

6. Sus Derechos
Usted tiene derecho a:
• Acceder a sus datos personales
• Solicitar la corrección de datos inexactos
• Solicitar la eliminación de sus datos
• Retirar su consentimiento en cualquier momento

7. Cambios en esta Política
Nos reservamos el derecho de actualizar esta política de privacidad en cualquier momento. Los cambios serán publicados en esta página.
`;
const termsContent = `
Términos y Condiciones

Última actualización: Marzo 2026

1. Aceptación de los Términos
Al acceder y utilizar este sitio web y adquirir nuestros productos digitales, usted acepta estar sujeto a estos términos y condiciones.

2. Productos Digitales
"Mente en Calma" es un producto digital (ebook) que se entrega electrónicamente. Una vez completada la compra, recibirá acceso inmediato al contenido.

3. Uso Personal
El contenido adquirido es para uso personal únicamente. Queda prohibida la reproducción, distribución o reventa del material sin autorización expresa.

4. Garantía de Devolución
Ofrecemos una garantía de devolución de 7 días. Si no está satisfecho con el producto, puede solicitar un reembolso completo dentro de los 7 días posteriores a la compra.

5. Descargo de Responsabilidad
El contenido de "Mente en Calma" tiene fines educativos e informativos únicamente. No sustituye el consejo médico profesional, diagnóstico o tratamiento. Consulte siempre a un profesional de la salud calificado.

6. Propiedad Intelectual
Todo el contenido, incluyendo textos, gráficos, logos y material audiovisual, está protegido por derechos de autor y es propiedad exclusiva de Mente en Calma.

7. Limitación de Responsabilidad
No garantizamos resultados específicos. Los resultados individuales pueden variar. No nos hacemos responsables por daños directos o indirectos derivados del uso de nuestros productos.

8. Modificaciones
Nos reservamos el derecho de modificar estos términos en cualquier momento. Las modificaciones entrarán en vigor inmediatamente después de su publicación.

9. Ley Aplicable
Estos términos se rigen por las leyes de la República Argentina.
`;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-8 px-4 border-t border-white/10" data-id="element-10">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-muted" data-id="element-11">
          <span className="opacity-60" data-id="element-12">© 2026 Mente en Calma</span>
          <span className="hidden sm:inline opacity-30" data-id="element-13">·</span>
          <button onClick={() => setActiveModal('privacy')} className="opacity-60 hover:opacity-100 hover:text-warm transition-opacity duration-200 underline underline-offset-2" data-id="element-14">
            Política de Privacidad
          </button>
          <span className="hidden sm:inline opacity-30" data-id="element-15">·</span>
          <button onClick={() => setActiveModal('terms')} className="opacity-60 hover:opacity-100 hover:text-warm transition-opacity duration-200 underline underline-offset-2" data-id="element-16">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      <AnimatePresence data-id="element-17">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-18">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 10
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 10
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} className="bg-card border border-white/10 rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-19">
              <div className="flex items-center justify-between p-6 border-b border-white/10" data-id="element-20">
                <h3 className="text-xl font-serif font-bold text-main" data-id="element-21">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="text-muted hover:text-main transition-colors p-1 rounded-lg hover:bg-white/10" data-id="element-22">
                  <XIcon size={20} data-id="element-23" />
                </button>
              </div>
              <div className="p-6 overflow-y-auto" data-id="element-24">
                <pre className="whitespace-pre-wrap font-sans text-sm md:text-base text-muted leading-relaxed" data-id="element-25">
                  {activeModal === 'privacy' ? privacyContent.trim() : termsContent.trim()}
                </pre>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}